export const getBoundsForMarkets = (
  markets,
  location,
  numberOfMarkets,
  marginInPercentage
) => {
  const marketsAndLocation = markets.slice(0, numberOfMarkets).concat(location)

  const marketsAndLocationMaximums = getMaximums(marketsAndLocation)

  const maxDistance = Math.max(
    marketsAndLocationMaximums.greatestLat -
      marketsAndLocationMaximums.smallestLat,
    marketsAndLocationMaximums.greatestLon -
      marketsAndLocationMaximums.smallestLon
  )

  const locationMargins = getMarginBounds(
    location,
    parseFloat((maxDistance * marginInPercentage) / 100)
  )

  const marketsMaxPoints = {
    ne: {
      lat: marketsAndLocationMaximums.greatestLat,
      lng: marketsAndLocationMaximums.greatestLon
    },
    sw: {
      lat: marketsAndLocationMaximums.smallestLat,
      lng: marketsAndLocationMaximums.smallestLon
    }
  }

  const { smallestLon, smallestLat, greatestLon, greatestLat } = getMaximums([
    marketsMaxPoints.ne,
    marketsMaxPoints.sw,
    locationMargins.ne,
    locationMargins.sw
  ])

  return {
    ne: {
      lat: greatestLat + 0.001,
      lng: greatestLon + 0.001
    },
    sw: {
      lat: smallestLat - 0.001,
      lng: smallestLon - 0.001
    }
  }
}

const getMarginBounds = (geoPoint, margin) => {
  const geoPointLat = geoPoint['address.lat'] || geoPoint.lat
  const geoPointLon = geoPoint['address.lon'] || geoPoint.lng || geoPoint.lon
  return {
    ne: { lat: geoPointLat + margin, lon: geoPointLon + margin },
    sw: { lat: geoPointLat - margin, lon: geoPointLon - margin }
  }
}

const getMaximums = locations => {
  let smallestLon, smallestLat, greatestLon, greatestLat

  locations.forEach(item => {
    const itemLat = item['address.lat'] || item.lat
    const itemLon = item['address.lon'] || item.lng || item.lon
    if (itemLat > greatestLat || !greatestLat) greatestLat = parseFloat(itemLat)
    if (itemLon > greatestLon || !greatestLon) greatestLon = parseFloat(itemLon)
    if (itemLat < smallestLat || !smallestLat) smallestLat = parseFloat(itemLat)
    if (itemLon < smallestLon || !smallestLon) smallestLon = parseFloat(itemLon)
  })
  return { smallestLon, smallestLat, greatestLon, greatestLat }
}
